module.exports = __webpack_public_path__ + "img/warehousing-distribution.d9cff808.jpg";